import { render, staticRenderFns } from "./EmployeesDeclaration.vue?vue&type=template&id=2fffd9cc&"
import script from "./EmployeesDeclaration.vue?vue&type=script&lang=js&"
export * from "./EmployeesDeclaration.vue?vue&type=script&lang=js&"
import style0 from "./EmployeesDeclaration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports